import BookingFormSummary, {
  FormData as FormDataExport,
} from './BookingFormSummary';

export type FormData = FormDataExport;
export default BookingFormSummary;
